import { all, takeLatest } from "redux-saga/effects";
import {
  PRODUCT_LIST,
  PRODUCT_DETAILS,
  ADD_PRODUCT,
  UPDATE_PRODUCT,
  DELETE_PRODUCT,
  PREVIEW_BULK_PRODUCT,
  UPLOAD_BULK_PRODUCT,
  ALL_PRODUCTS,
  UPLOAD_SYNC_PRODUCTS,
  UPLOAD_SYNC_IMAGE,
} from "../actions/product.actions.types";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";

const call = Effects.call;

function* getProductList({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "products/list",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* getAllProductList({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "products/list-for-coupon",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}
function* syncProductsImage({ payload: { callback } }) {
  const payload = {
    method: "get",
    url: "products/image-sync",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* productDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `products/admin/product-details/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* addProduct({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "products",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* previewBulkProduct({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "products/bulk-preview",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
    formData: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* uploadBulkProduct({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "products/bulk-upload",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
    formData: true,
  });
  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* updateProduct({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: `products/${data._id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteProduct({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `products/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    successMessage(result.message);
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* uploadSyncProducts({ payload: { callback } }) {
  const payload = {
    method: "get",
    url: `products/sync-products`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* Product() {
  yield all([
    takeLatest(PRODUCT_LIST, getProductList),
    takeLatest(ALL_PRODUCTS, getAllProductList),
    takeLatest(PRODUCT_DETAILS, productDetails),
    takeLatest(ADD_PRODUCT, addProduct),
    takeLatest(UPDATE_PRODUCT, updateProduct),
    takeLatest(DELETE_PRODUCT, deleteProduct),
    takeLatest(PREVIEW_BULK_PRODUCT, previewBulkProduct),
    takeLatest(UPLOAD_BULK_PRODUCT, uploadBulkProduct),
    takeLatest(UPLOAD_SYNC_PRODUCTS, uploadSyncProducts),
    takeLatest(UPLOAD_SYNC_IMAGE, syncProductsImage),
  ]);
}

export default Product;
